<template>
  <div>
    <div class="page-title underline mb-4"><mdb-icon  icon="comment-dots" /> 회의록</div>
    <mdb-row v-if="training && training._id">
      <mdb-col md="4" v-if="subjects">
        <proceeding-category/>
      </mdb-col>
      <mdb-col md="8">
        <router-view/>
      </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import lectureService from '@/service/training/subject'
import Proceeding from '@/models/Proceeding.js';
import ProceedingEdit from '@/components/comm/proceeding/ProceedingEdit.vue';
import ProceedingCategory from '@/components/comm/proceeding/ProceedingCategory.vue';
export default {
  name: 'StaffProceedingPage',
  components: { ProceedingCategory },
  props: [],
  data: () => ({
  }),
  computed: {
    ...mapState('training', ['training', 'subjects'])
  },
  methods: {
    async onSelectNcsLecture (subject, lecture) {
      this.proceeding = this.proceedings.NCS[lecture.name] || Proceeding.create(
        this.training._id, subject, lecture.name, lecture.code)
      this.category = 'NCS'
    },
    async onSelectNonncsSubject (subject) {
      this.proceeding = this.proceedings.NONNCS[subject] || Proceeding.create(
        this.training._id, subject)
      this.category = 'NONNCS'
    },
    async onSelectOccasional (lecture) {
      this.proceeding = this.proceedings['비정기 회의록'][lecture] || Proceeding.create(
        this.training._id, '비정기 회의록', lecture)
      this.category = '비정기 회의록'
    },
    async onSave () {
      if (confirm('저장할까요?')) {
        await this.proceeding.save();
      }
    },
    async onDelete () {
      if (confirm('삭제할까요?')) {
        if (this.proceeding._id) {
          await this.proceeding.delete();
        }
        if (this.category === 'NONNCS') {
          if (this.proceedings[this.category][this.proceeding.subject]) {
            delete this.proceedings[this.category][this.proceeding.subject]
          }
        } else {
          if (this.proceedings[this.category][this.proceeding.lectureName]) {
            delete this.proceedings[this.category][this.proceeding.lectureName]
          }
        }
      }
    }
  }
}
</script>
